import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import { MagnifyingGlass, CaretRight, IdentificationCard, Leaf, CalendarCheck, FileText, CurrencyCircleDollar, Percent, UsersThree, ChatCircle, Gear } from "@phosphor-icons/react";
import { CATEGORIES, SETTING_SEARCH_INDEX } from "./settingsCategories";

const ICONS = {
  profile: IdentificationCard, services: Leaf, scheduling: CalendarCheck, quotes: FileText,
  invoicing: CurrencyCircleDollar, tax: Percent, crew: UsersThree, messages: ChatCircle, account: Gear,
};

export default function SettingsHome() {
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const matches = q.trim().length > 1
    ? SETTING_SEARCH_INDEX.filter((x) => (x.label + " " + x.keywords).toLowerCase().includes(q.trim().toLowerCase())).slice(0, 8)
    : [];
  return (
    <Layout title="Settings">
      <div className="space-y-4">
        <div className="relative" data-testid="settings-search-wrap">
          <MagnifyingGlass size={18} weight="bold" className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input data-testid="settings-search" className="field-input w-full !pl-11" placeholder="Find a setting by name…"
            value={q} onChange={(e) => setQ(e.target.value)} />
          {matches.length > 0 && (
            <div className="absolute inset-x-0 top-full z-30 mt-1 overflow-hidden rounded-md border border-border bg-background shadow-lg" data-testid="settings-search-results">
              {matches.map((m) => (
                <button key={m.id} data-testid={`settings-search-${m.id}`}
                  onClick={() => nav(`/settings/${m.cat}#${m.anchor}`)}
                  className="flex w-full items-center justify-between px-4 py-3 text-left text-sm font-semibold transition-colors hover:bg-muted/50">
                  <span>{m.label}</span>
                  <span className="text-xs font-normal text-muted-foreground">{CATEGORIES.find((c) => c.id === m.cat)?.title}</span>
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="space-y-2" data-testid="settings-categories">
          {CATEGORIES.map((c) => {
            const Icon = ICONS[c.id];
            return (
              <Link key={c.id} to={`/settings/${c.id}`} data-testid={`settings-cat-${c.id}`}>
                <div className="card-flat flex items-center gap-4 p-5 transition-colors hover:bg-muted/50">
                  <Icon size={28} weight="bold" className="shrink-0 text-primary" />
                  <div className="flex-1">
                    <p className="font-semibold">{c.title}</p>
                    <p className="text-sm text-muted-foreground">{c.desc}</p>
                  </div>
                  <CaretRight size={20} weight="bold" className="text-muted-foreground" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
